import './index.css';
import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-101" />, document.getElementById('root'));
const sendHeight = () => {
  const height = document.documentElement.scrollHeight;
  window.parent.postMessage({
    type: 'ofri:iframe-height',
    height
  }, '*');
};
window.addEventListener('load', sendHeight);
window.addEventListener('resize', sendHeight);
setTimeout(sendHeight, 300);